var _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageToPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#D3CCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.7647C16 14.7612 16 15.7595 15.4142 16.3798C14.8284 17 13.8856 17 12 17H10C8.11438 17 7.17157 17 6.58579 16.3798C6 15.7595 6 14.7612 6 12.7647V9.23529C6 7.23876 6 6.24049 6.58579 5.62024C7.17157 5 8.11438 5 10 5H12C13.8856 5 14.8284 5 15.4142 5.62024C16 6.24049 16 7.23876 16 9.23529V12.7647Z",
    stroke: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7C17.1046 7 18 7.9481 18 9.11765V13.3529C18 16.015 18 17.346 17.219 18.173C16.4379 19 15.1808 19 12.6667 19H10C8.89543 19 8 18.0519 8 16.8824",
    stroke: "#1D1D1D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 8,
    r: 1,
    stroke: "#1D1D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.408L7.3297 9.74584C7.76135 9.40138 8.41192 9.42114 8.81749 9.79103L10.8495 11.6442C11.175 11.9411 11.6874 11.9816 12.0641 11.7402L12.2053 11.6496C12.7473 11.3022 13.4807 11.3425 13.9731 11.7467L15.5 13",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageToPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image-to-pdf.42a79927946de91f503b0f193298160f.svg";